import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
// const options = {role: ROLE.SUPER_ADMIN};
const options = {};

const path = "admin/temple"

export const TempleList = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
}

export const TempleAdd = async (values) => {
    return await axiosInstance(options).post(`${path}/add`, values);
}

export const TempleDelete = async (id) => {
  return await axiosInstance(options).delete(`${path}/delete`, {
    params: {
      o_id: id,
    },
  });
};

export const TempleDetails = async (id) => {
    return await axiosInstance(options).get(`${path}/details?o_id=${id}`);
}


export const TempleEdit = async (values) => {
    return await axiosInstance(options).post(`${path}/edit`, values);
}

export const TempleStatusChange = async (values) => {
    return await axiosInstance(options).post(`${path}/change-status`, values);
}


